import _                                    from 'underscore';
import React, { FC, useContext, useEffect } from 'react';

import { usePageMeta }       from '../../hooks';
import { STRING_CONVERSION } from '../../constants/FormatStringEnums';
import { ProjectContext }    from '../pages/projects/ProjectIndexPage';

interface Props {
	section?: string,
	title?: string,
	description?: string
}

const defaultProps: Props = {
	section:     null,
	title:       null,
	description: null,
}

const PageMeta: FC<Props> = React.memo<Props>( ( props ) => {
	
	let metaFunctions  = usePageMeta(),
	    projectContext = useContext( ProjectContext );
	
	useEffect( () => {
		
		if( props.title ){
			
			metaFunctions.updatePageTitle( props.title,
				projectContext
				? _.compact( [ projectContext.projectName, props.section ] ).join( ` ${ STRING_CONVERSION.DELIMITER } ` )
				: props.section
			);
		}
		
	}, [ props ] )
	
	return ( <>{ props.children }</> )
	
} );

PageMeta.defaultProps = defaultProps;

export { PageMeta }
